// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"f45cf1704c37ff602e0b","303":"134d6c6aa76801d8f10c","495":"791a250a6ddf749054c2"}[chunkId] + ".js";
};